import React, { useState, useContext } from "react";
import loginimage from "../../assets/new-images/loginimage.webp";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { api } from "../Constants";
function Login() {
  const [authMode, setAuthMode] = useState("login");
  const [isOtpStep, setIsOtpStep] = useState(false);
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");

  const navigate = useNavigate();

  const handlePhoneChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    setPhone(numericValue);
  };

  const handleOtpChange = (e) => {
    const numericValue = e.target.value.replace(/[^0-9]/g, "");
    setOtp(numericValue);
  };

  const switchToOtpLogin = (e) => {
    e.preventDefault();
    setAuthMode("otp");
    resetFields();
  };

  const switchToLogin = (e) => {
    e.preventDefault();
    setAuthMode("login");
    setIsOtpStep(false);
    resetFields();
  };

  const resetFields = () => {
    setPhone("");
    setOtp("");
  };

  const handlePhoneSubmit = (e) => {
    e.preventDefault();
    if (phone.length === 10) {
      setIsOtpStep(true);
    }
  };

  const handleOtpSubmit = (e) => {
    e.preventDefault();
    console.log("Verifying OTP:", otp);
  };

  const [inputfields, setInputfields] = useState({
    emailid: "",
    password: "",
  });

  const [errors, setErrors] = useState({});

  const [errorcredentials, setErrorcredentials] = useState("");

  const handlechange = (e) => {
    setInputfields({ ...inputfields, [e.target.name]: e.target.value });
  };

  const validateerrors = (fields) => {
    let errors = {};

    if (!fields.emailid || fields.emailid.trim() === "") {
      errors.emailid = "Email Id is required";
    }

    if (!fields.password || fields.password.trim() === "") {
      errors.password = "Password is required";
    }
    return errors;
  };

  const handleloginSubmit = (e) => {
    e.preventDefault();
    setErrorcredentials("");
    const validationerrors = validateerrors(inputfields);
    setErrors(validationerrors);

    if (Object.keys(validationerrors).length === 0) {
      const logindata = async () => {
        await axios
          .post(api + "dealer_login", {
            user_name: inputfields.emailid,
            password: inputfields.password,
          })
          .then((res) => {
            toast.success(res.data.message);
            navigate("/");
            console.log(res);
            if (res.data.success === true) {
              localStorage.setItem("username", res.data.data.name);
              localStorage.setItem("email", res.data.data.email);
              localStorage.setItem("phone", res.data.data.mobile);
              localStorage.setItem("userid", res.data.data.dealer_id);
            }
            setInputfields({ emailid: "", password: "" });
          })
          .catch((error) => {
            toast.error(error.response.data.message);
            setErrorcredentials(error.response.data.message);
          });
      };
      logindata();
    }
  };

  const [otpphonenumber, setOtpphonenmber] = useState({
    phonenumber: "",
  });
  const [otperrors, setOtperrors] = useState({});

  const handlechangeotpphonenumber = (e) => {
    const { name, value } = e.target;

    if (/^\d*$/.test(value)) {
      setOtpphonenmber({ ...otpphonenumber, [name]: value });
    }
  };

  const validateotperrors = (otpfields) => {
    let otperrors = {};

    if (!otpfields.phonenumber || otpfields.phonenumber.trim() == "") {
      otperrors.phonenumber = "Phone Number is required";
    } else if (!/^\d{10,11}$/.test(otpfields.phonenumber)) {
      otperrors.phonenumber = "Phone number must be 10  digits";
    }

    return otperrors;
  };

  const handleotpSubmits = (e) => {
    e.preventDefault();

    const otpvaliateerrors = validateotperrors(otpphonenumber);
    setOtperrors(otpvaliateerrors);

    if (Object.keys(otpvaliateerrors).length === 0) {
    }
  };

  return (
    <section className="py-5">
      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-lg-6 d-none d-lg-block">
            <img src={loginimage} alt="Login Visual" className="img-fluid" />
          </div>

          <div className="col-lg-6">
            <div className="card shadow-sm">
              <div className="card-body">
                <h2 className="card-title mb-4 text-center">
                  {authMode === "otp" && isOtpStep
                    ? "Enter OTP (Phone)"
                    : authMode === "otp"
                    ? "Login with OTP"
                    : "Login"}
                </h2>

                {/* Login with OTP (Phone) */}
                {authMode === "otp" && (
                  <>
                    {!isOtpStep ? (
                      <>
                        <form onSubmit={handleotpSubmits}>
                          <div className="mb-3">
                            <label htmlFor="phone" className="form-label">
                              Enter your registered mobile number{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <input
                              type="tel"
                              className="form-control"
                              name="phonenumber"
                              placeholder="Phone"
                              value={otpphonenumber.phonenumber}
                              onChange={handlechangeotpphonenumber}
                              maxLength={10}
                            />
                            {otperrors ? (
                              <p style={{ fontSize: "12px", color: "red" }}>
                                {otperrors.phonenumber}
                              </p>
                            ) : null}
                          </div>
                          <div className="mb-3 text-center">
                            <button
                              type="submit"
                              className="btn"
                              style={{
                                backgroundColor: "#bc1823",
                                borderColor: "#bc1823",
                                color: "#fff",
                                padding: "0.5rem 1.5rem",
                              }}
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                      </>
                    ) : (
                      <>
                        <div className="mb-3">
                          <label htmlFor="otp" className="form-label">
                            Enter OTP <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="otp"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={handleOtpChange}
                            maxLength={6}
                          />
                        </div>
                        <div className="mb-3 text-center">
                          <Link to={"/"}>
                            <button
                              onClick={handleOtpSubmit}
                              className="btn"
                              style={{
                                backgroundColor: "#bc1823",
                                borderColor: "#bc1823",
                                color: "#fff",
                                padding: "0.5rem 1.5rem",
                              }}
                            >
                              Verify OTP
                            </button>
                          </Link>
                        </div>
                      </>
                    )}

                    <div className="text-center">
                      <button onClick={switchToLogin} className="btn btn-link">
                        Back to Login
                      </button>
                    </div>
                  </>
                )}

                {/* Email/Password Login */}
                {authMode === "login" && (
                  <form onSubmit={handleloginSubmit}>
                    <div className="mb-3">
                      <label htmlFor="email" className="form-label">
                        Email id (or) Mobile Number{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        name="emailid"
                        placeholder="Enter Email id (or) Mobile Number"
                        value={inputfields.emailid}
                        onChange={handlechange}
                      />
                      {errors.emailid && (
                        <p style={{ fontSize: "12px", color: "red" }}>
                          {errors.emailid}
                        </p>
                      )}
                    </div>

                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">
                        Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        name="password"
                        placeholder="Enter your password"
                        value={inputfields.password}
                        onChange={handlechange}
                      />
                      {errors.password && (
                        <p style={{ fontSize: "12px", color: "red" }}>
                          {errors.password}
                        </p>
                      )}
                    </div>

                    {errorcredentials ? (
                      <p
                        className="text-center"
                        style={{ fontSize: "12px", color: "red" }}
                      >
                        {errorcredentials}
                      </p>
                    ) : null}

                    <div className="mb-3 text-center">
                      <button
                        type="submit"
                        className="btn"
                        style={{
                          backgroundColor: "#bc1823",
                          borderColor: "#bc1823",
                          color: "#fff",
                          padding: "0.5rem 1.5rem",
                        }}
                      >
                        Login
                      </button>
                    </div>

                    {/* <div className="mt-3 text-center">
                      <p>
                        <a
                          href="#"
                          onClick={switchToOtpLogin}
                          style={{ color: "#bc1823", textDecoration: "none" }}
                        >
                          Login with phone number
                        </a>
                      </p>
                    </div> */}
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Login;
